export default __webpack_public_path__ + "static/media/Exceptional_service.372eb188.jpg";